<template>
    <page>
        <module>
            <c-form ref="form">
              <c-form title="数据大屏配置">
                <c-form-item type="number" :limit="[0, 9999]" decimal="2" label="【虚拟】GMV系数" name="virtual_gmv_coefficient"
                             word="省份地图数据展示信息 = 实际值*系数；影响【省份地址】、【销售TOP区域】数据" ></c-form-item>
<!--                <c-form-item type="number" :limit="[0, 9999]" decimal="2" label="【虚拟】订单系数" name="order_coefficient"-->
<!--                             word="大屏展示数据 = 实际订单数量*系数" ></c-form-item>-->
                <c-form-item type="number" :limit="[0, 999999999]" label="【虚拟】新星会员数量" name="virtual_level_0_11"
                             word="大屏展示数据 = 实际新星会员数量 + 虚拟值" ></c-form-item>
                <c-form-item type="number" :limit="[0, 999999999]" label="【虚拟】精英会员数量" name="virtual_level_0_12"
                             word="大屏展示数据 = 实际精英会员数量 + 虚拟值" ></c-form-item>
                <c-form-item type="number" :limit="[0, 999999999]" label="【虚拟】黄金会员数量" name="virtual_level_0_13"
                             word="大屏展示数据 = 实际黄金会员数量 + 虚拟值" ></c-form-item>
                <c-form-item type="number" :limit="[0, 999999999]" label="【虚拟】铂金会员数量" name="virtual_level_0_14"
                             word="大屏展示数据 = 实际铂金会员数量 + 虚拟值" ></c-form-item>
                <c-form-item type="number" :limit="[0, 999999999]" label="【虚拟】钻石会员数量" name="virtual_level_0_15"
                             word="大屏展示数据 = 实际钻石会员数量 + 虚拟值" ></c-form-item>
                <c-form-item type="number" :limit="[0, 999999999]" label="【虚拟】至尊会员数量" name="virtual_level_0_16"
                             word="大屏展示数据 = 实际至尊会员数量 + 虚拟值" ></c-form-item>
                <c-form-item type="number" :limit="[0, 999999999]" label="【虚拟】门店数量" name="virtual_level_10"
                             word="大屏展示数据 = 实际门店数量 + 虚拟值"></c-form-item>
                <c-form-item type="number" :limit="[0, 999999999]" label="【虚拟】运营商数量" name="virtual_level_20" word="大屏展示数据 = 实际运营商数量 + 虚拟值"></c-form-item>
                <c-form-item type="number" :limit="[0, 999999999]" label="【虚拟】服务商数量" name="virtual_level_30" word="大屏展示数据 = 实际服务商数量 + 虚拟值"></c-form-item>
                <c-form-item type="number" :limit="[0, 999999999]" label="【虚拟】联创数量" name="virtual_level_40" word="大屏展示数据 = 实际联创数量 + 虚拟值"></c-form-item>
                <c-form-item type="number" :limit="[0, 999999999]" label="【虚拟】累计发放奖励" name="virtual_award_money"
                             word="大屏展示数据 = 实际奖励 + 虚拟值；影响【累计发放奖励】数据"></c-form-item>
                <c-form-item type="number" :limit="[1, 9999]" decimal="2" label="【虚拟】奖励系数" name="award_coefficient"
                             word="大屏展示数据 = 实际奖励 *系数；影响【佣金奖励总榜】、【近30条分享奖励排行】两个功能" ></c-form-item>
              </c-form>
            </c-form>
          <template slot="button">
                <c-button size="m" @click="save()">保存</c-button>
            </template>
        </module>

    </page>
</template>

<script>

    export default {
        name: 'm_digital_config',

        components: {
        },

        props: {
            id: String
        },

        data() {
            return {
            }
        },

        watch: {

        },

        mounted() {
            this.getDetail();
        },

        methods: {
            getDetail() {
                this.request({
                    url: '/visual/data/config',
                    data: {},
                    loading: true,
                    success: data => {
                        var configMap = data;
                        console.log(configMap);
                        this.$nextTick(() => {
                            if (this.$refs.form) this.$refs.form.set(configMap);
                        })
                    }
                });
            },


            save() {
                let data0 = this.$refs.form ? this.$refs.form.get() : {};
                let submitData = Object.assign({}, data0);
                this.request({
                    url: '/visual/data/config/edit',
                    data: {
                        data_visual_json: JSON.stringify(submitData)
                    },
                    dataFormatter: data => {
                        return data;
                    },
                    success: data => {
                        this.$message({
                            text: '保存成功',
                            icon: 'success'
                        });
                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>
  .box {
    padding: 15px;
    background: #f9f8fb;
  }

  .product {
    position: relative;
    width: 90px;
    height: 90px;
    border: 1px solid #DDDDDD;
    margin-right: 15px;
    margin-top: 15px;
    background: #fff;
    box-sizing: border-box;

    video {
      width: 100%;
      height: 100%;
      background: #000;
    }

    a {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 18px;
      height: 18px;
      font-size: 12px;
      color: #fff;
      background: #FF1010;
    }

    &-list {
      margin-top: -15px;
    }

    &-add {
      font-size: 20px;
      color: #ccc;
      cursor: pointer;
      transition: all .3s ease;

      &:hover {
        border-color: #bbb;
        color: #bbb;
      }
    }
  }
</style>